import type { FC } from 'react';
import track from 'react-tracking';
import { Section, Divider } from './Breadcrumb';
import { RouterLink } from '@redux-first-router-link';

interface DispatchObj {
  type: string;
  payload?: {
    [key: string]: string | number | boolean;
  };
}
interface LinkItem {
  name: string;
  url?: string;
  dispatch?: DispatchObj;
}

interface GenericRenderProps {
  value: LinkItem;
  isLast: boolean;
  isSecondToLast: boolean;
  index: number;
  isOnlyOne: boolean;
}

/* The most generic usage of the <Breadcrumb/> component */
const GenericRender: FC<GenericRenderProps & Tracking> = ({
  value,
  isLast,
  index,
  tracking: { trackEvent },
}) => {
  if (!isLast) {
    return (
      <>
        <Section active={!value.dispatch}>
          {value.dispatch ? (
            <RouterLink
              data-cy-id={`child-link-${index}`}
              to={value.dispatch}
              inheritColor
              noUnderline={false}
              onClick={() =>
                trackEvent({
                  label: value.name,
                })
              }
            >
              {value.name}
            </RouterLink>
          ) : (
            <span data-cy-id={`child-link-${index}`}>{value.name}</span>
          )}
        </Section>
        <Divider />
      </>
    );
  } else {
    return (
      <Section active={!value.dispatch}>
        {value.dispatch ? (
          <RouterLink
            data-cy-id={`child-link-${index}`}
            to={value.dispatch}
            inheritColor
            noUnderline={false}
            onClick={() =>
              trackEvent({
                label: value.name,
              })
            }
          >
            {value.name}
          </RouterLink>
        ) : (
          <span data-cy-id={`child-link-${index}`}>{value.name}</span>
        )}
      </Section>
    );
  }
};

export default track(({ index }) => ({
  action: 'click',
  modifier: 'crumb',
  index: index,
}))(GenericRender);
